import { handleActions } from "redux-actions";
import { setPoints, setCountPoints } from "../action";

const initialState = {
    items: [],
    count: 0,
    error: null,
    loading: false,
};

const points = handleActions(
    {
        [setPoints]: (state, { payload }) => ({
            ...state,
            items: payload,
        }),
        [setCountPoints]: (state, { payload }) => ({
            ...state,
            count: payload,
        }),
        'SET_LOADER': (state, action) => {
            if (action.field === 'points') {
                return { ...state, loading: action.value };
            }
            return state;
        },
    },
    initialState
);

export default points;
